import React from 'react';
import { Typography, useTheme } from '@mui/material';
import { InformationChip } from '@europrocurement/flexy-components';

export type OrderStatusProps = {
    status:
        | 'NOTBILLED'
        | 'PARTIALLYBILLED'
        | 'FULLYBILLED'
        | 'UNQUOTED'
        | 'QUOTED'
        | 'INCOMPLETEFORBILLING'
        | 'COMPLETEFORBILLING';
};

const OrderStatus: React.FunctionComponent<OrderStatusProps> = function (props) {
    const { status } = props;
    const { palette } = useTheme();
    let color: string = palette.primary.main;
    let bgColor: string = 'primary';
    let label: string = '';

    switch (status) {
        case 'NOTBILLED':
            label = 'Non facturé';
            color = palette.grey['600'];
            bgColor = palette.grey['400'];
            break;
        case 'PARTIALLYBILLED':
            label = 'Partiellement facturé';
            color = palette.warning.dark;
            bgColor = 'warning';
            break;
        case 'FULLYBILLED':
            label = 'Facturé';
            color = palette.success.dark;
            bgColor = 'success';
            break;
        case 'UNQUOTED':
            label = 'Non devisé';
            color = palette.grey['600'];
            bgColor = palette.grey['400'];
            break;
        case 'QUOTED':
            label = 'Devisé';
            color = palette.success.dark;
            bgColor = 'success';
            break;
        case 'INCOMPLETEFORBILLING':
            label = 'Incomplet pour facturation';
            color = palette.warning.dark;
            bgColor = 'warning';
            break;
        case 'COMPLETEFORBILLING':
            label = 'Complet pour facturation';
            color = palette.success.dark;
            bgColor = 'success';
            break;
        default:
            label = '';
            break;
    }

    return (
        <InformationChip
            color={bgColor}
            label={
                <Typography
                    variant="l2dtableCell"
                    color={color}
                >
                    {label}
                </Typography>
            }
        />
    );
};

export default OrderStatus;
